import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { initFormModalLinks } from '../../shared/formModal.js';
import { confirmAction, hideLoading, notifyError, showLoading } from '../../shared/notify.js';

// What each row button does, so the handler below stays a lookup rather than a
// chain of ifs.
const ACTIONS = {
  delete: {
    confirm: (name) => ({
      title: 'Filiale löschen',
      message: `Möchten Sie ${name} endgültig löschen? Das kann nicht rückgängig gemacht werden.`,
      okText: 'Löschen'
    }),
    loading: 'Filiale wird gelöscht …',
    flash: 'filiale-geloescht',
    run: (id) => http.delete(`/filialen/${id}`)
  }
};

export function initFilialeList() {
  const list = document.getElementById('filiale-list');
  if (!list) return;

  // Creating and editing happen in the shared dialog rather than on their own
  // page. The links keep their href, so a middle click still opens the real
  // page and nothing breaks with the bundle absent - initFormModalLinks only
  // intercepts a plain left click.
  //
  // Delegated from document, because the "create" button sits in the page
  // header rather than inside the table.
  initFormModalLinks({
    selector: 'a[href$="/new"], a[href$="/edit"]',
    // No live refresh on this list yet, so the page reload is what shows the
    // change - the same round trip it did before, minus the one it used to
    // take to reach the form.
    onSaved: () => window.location.reload()
  });

  // One delegated listener for the whole table, so rows cost nothing to add.
  list.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-action]');
    if (!button) return;

    const action = ACTIONS[button.dataset.action];
    if (!action) return;

    const { filialeId, filialeName } = button.dataset;

    if (action.confirm && !(await confirmAction(action.confirm(filialeName)))) return;

    button.disabled = true;
    showLoading(action.loading);

    try {
      await action.run(filialeId);
      window.location.href = withFlash('/filialen', action.flash);
    } catch (err) {
      hideLoading();
      button.disabled = false;
      // A branch that still employs people answers 409 with a message naming
      // how many, which is more useful than the generic fallback.
      notifyError(
        err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      );
    }
  });
}
